// Profile app routes

export const ROUTES = {
  LOGIN: '/login',
  PERSONAL_INFO: '/personalinfo',
  SECURITY: '/security',
  SETTINGS: '/settings',
  HOME: '/',
};
